import React from 'react';
import moment from "moment";
import { timeZoneOptions } from '../../../constants/FilterData';
import dayjs from 'dayjs';

export const mapEvents = (eventList) => {
  const events = [];
  if (eventList && eventList.length > 0) {
    eventList.map(event => {
      events.push({
        start: new Date(event.start),
        end: new Date(event.end),
        title: event.title,
        details: event.details
      });
    });
  }

  return events
};


const getDates = (inputDate) => {
    const compareDate = inputDate.toDateString();
    const displayDayName = inputDate.toLocaleString('default', {weekday: 'long'});
    const displayDate = inputDate.getDate();
    const displayMonth = inputDate.toLocaleString('default', {month: 'long'});
    const displayYear = inputDate.getFullYear();
    return {inputDate, compareDate, displayDayName, displayDate, displayMonth, displayYear};
  };

export  const getDisplayTime = (inputTime) => {
    let hours = inputTime.toLocaleString('default', {hour: 'numeric'});
    let minutes = inputTime.toLocaleString('default', {minute: 'numeric'});
    let newFormat = hours >= 12 ? ' PM' : ' AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ":" + minutes + newFormat
  };

export const displayDateFormat = (start, end) => {
    let allDay = false;
    let displayString = '';
    const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());
    if (startDate === endDate || startDate < endDate) {
      allDay = true;
    }
    if (allDay) {

      let startValues = getDates(start);
      let endValues = getDates(end);

      if (startValues.compareDate === endValues.compareDate) {
        displayString = startValues.displayDayName + ', ' + startValues.displayDate + ' ' + startValues.displayYear;
      } else {
        displayString = startValues.displayDate + ' - ' + endValues.displayDate + ' ' + startValues.displayMonth + ' ' + startValues.displayYear
      }
    } else {
      let startValues = getDates(start);
      let endValues = getDates(end);
      const displayStartString = getDisplayTime(start);
      const displayEndString = getDisplayTime(end);
      if (startValues.compareDate === endValues.compareDate) {
        displayString = startValues.displayDayName + ', ' + startValues.displayDate + ' ' + startValues.displayMonth + ' ' + displayStartString + ' - ' + displayEndString
      } else {
        displayString = startValues.displayDate + ' ' + startValues.displayMonth + ' ' + startValues.displayYear + ', ' + displayStartString
          + ' - ' + endValues.displayDate + ' ' + endValues.displayMonth + ' ' + endValues.displayYear + ', ' + displayEndString

      }
    }
    return displayString;
  };

export const getAttendeeInformation = (attendeeList, screenerId) => {
    if (attendeeList) {
      let confirm = 0;
      let waiting = 0;
      let isCalendarOwner = false;
      const totalGuests = attendeeList.length;
      attendeeList.map(attendee => {
        if (attendee.responseStatus === 'accepted') {
          confirm += 1;
        } else {
          waiting += 1;
        }
        if (attendee.email === screenerId){
          isCalendarOwner = true;
        }

      });
      return {totalGuests, confirm, waiting, isCalendarOwner};
    }
    return ''
  };

export const convertToUserReadable = (key) => {
    key = key.replace(/[/_/]/g, ' ');
    return key.toUpperCase()
  };

export const convertTZ = (date, tzString) => {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}


export const dateSplit_new = (date) => { // this is to check the date format on production remove this once test this is not used on other place
  if (!date || typeof date !== "string") {
      console.error("Invalid date input:", date);
      return null;
  }

  console.log("Received date:", date);

  const dateSplit = date.split(", ");
  if (dateSplit.length !== 2) {
      console.error("Invalid date format:", date);
      return null;
  }

  const datePart = dateSplit[0].split("/");
  const timePart = dateSplit[1].split(":");

  if (datePart.length !== 3 || timePart.length !== 3) {
      console.error("Invalid date or time parts:", { datePart, timePart });
      return null;
  }

  const year = parseInt(datePart[2], 10);
  const month = parseInt(datePart[1], 10) - 1; // Month is 0-based
  const day = parseInt(datePart[0], 10);
  const hours = parseInt(timePart[0], 10);
  const minutes = parseInt(timePart[1], 10);
  const seconds = parseInt(timePart[2], 10);

  if (
      isNaN(year) || isNaN(month) || isNaN(day) ||
      isNaN(hours) || isNaN(minutes) || isNaN(seconds)
  ) {
      console.error("Invalid numeric values for date:", { year, month, day, hours, minutes, seconds });
      return null;
  }

  const formattedDate = new Date(year, month, day, hours, minutes, seconds);

  if (isNaN(formattedDate.getTime())) {
      console.error("Generated an invalid date:", formattedDate);
      return null;
  }

  console.log("Final formatted date: 152 : ", formattedDate.toISOString());
  return formattedDate.toISOString();
};

export const dateSplit = (date) => {
    console.log('date',date)
    dateSplit_new(date) // this is to test only
    const dateSplit = date.split(',');
    console.log('ddate.split()',date && date.split(','))
    console.log('dateSplit 111',dateSplit)
    const datePart = dateSplit[0].split('/');
    console.log('datePart 114',datePart)
    const timePart = dateSplit[1].split(':');

    // console.log('results 117',new Date(datePart[2], datePart[1] - 1, datePart[0], timePart[0], timePart[1], timePart[2].slice(0,2)))
    // console.log('results 117',new Date(datePart[2], datePart[1] - 1, datePart[0], timePart[0], timePart[1], timePart[2].slice(0,2)))
    console.log('results 117',new Date(datePart[2], datePart[1] - 1, datePart[0] + 1, timePart[0], timePart[1], timePart[2].slice(0,2)))
    console.log('results 118',new Date(datePart[2], datePart[1] - 1, datePart[0] , timePart[0], timePart[1], timePart[2].slice(0,2)))
    console.log('results 119 toISOString',new Date(datePart[2], datePart[1], datePart[0], timePart[0], timePart[1], timePart[2].slice(0,2)).toLocaleString())

    // return new Date(datePart[2], datePart[1] - 1, datePart[0], timePart[0], timePart[1], timePart[2].slice(0,2)).toLocaleString();
    // return new Date(datePart[2], datePart[1] - 1, datePart[0], timePart[0], timePart[1], timePart[2].slice(0,2)).toISOString();
    return datePart[2]+"-"+datePart[1]+"-"+datePart[0]+"T"+timePart[0].trim()+":"+timePart[1]+":"+timePart[2]+".000Z"
  };

  export const displayDateInMMDDYYYYTime = (date) => {
    if (date && date !== "undefined") {
      return moment.utc(date).local().format('DD MMM. YYYY HH:mm:ss');
    } else {
      return "N/A";
    }
  }
export const displayDateInMMDDYYYY = (date) => {
  if (date && date !== "undefined") {
    // return moment.utc(date).local().format('DD MMM. YYYY');
      return moment.utc(date).format('DD MMM. YYYY');
  } else {
    return "N/A";
  }
}

export const displayTimeInLocalAMPM = (time) => {
  if(!time)return
  const timeObj = new Date(time);
  timeObj.setHours(timeObj.getHours() + 5); // Add 5 hours
  timeObj.setMinutes(timeObj.getMinutes() + 30); // Add 30 minutes

  if (time && time!== "undefined") {
      const formattedTime = timeObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });
    return formattedTime;
  } else {
    return "N/A";
  }
}

export const displayDateInDDMonYYYYFormat = (date) => {//formats MM/DD/YYYY only
  if (!date) return "N/A";
  // const parsedDate = dayjs(date, 'MM/DD/YYYY', true);
  const parsedDate = dayjs(date);
  if (parsedDate.isValid()) {
    return parsedDate.format('DD MMM. YYYY');
  } else {
    return "N/A";
  }
}

export const formatDateInYYYYMMDD = (startDate) => {
  return dayjs(startDate).format('YYYY-MM-DD');
};

export const displayInterviewSchedule = (startTime, endTime, timeZone) => {
  // const extraStartTimeKey = startTime ? startTime.split('+')[1] : 0
  // const extraEndTimeKey = endTime ? endTime.split('+')[1] : 0
  if (!startTime || !endTime) {
    return "N/A";
  }
  const extraStartTimeKey = startTime.includes('+') ? Number(startTime.split('+')[1]) : 0;
  const extraEndTimeKey = endTime.includes('+') ? Number(endTime.split('+')[1]) : 0;

  const parsedStartTime = dayjs(startTime);
  const parsedEndTime = dayjs(endTime);
  // const parsedStartTime = dayjs(startTime, moment.ISO_8601, true);
  // const parsedEndTime = dayjs(endTime, moment.ISO_8601, true);
  if (!parsedStartTime.isValid() || !parsedEndTime.isValid()) {
    return "N/A";
  }
  // const formattedStartTime = parsedStartTime.local().format('DD MMM. YYYY h:mmA');
  // const formattedEndTime = parsedEndTime.local().format('h:mmA');
  const startDate = startTime && dayjs(parsedStartTime).add(extraStartTimeKey,'hours').local().format('DD MMM. YYYY');
  const startLocalTime = startTime && dayjs(parsedStartTime).add(extraStartTimeKey,'hours').local().format('h:mmA');
  const endlocalTime = endTime&& dayjs(parsedEndTime).add(extraEndTimeKey,'hours').local().format('h:mmA');
  const getTimeZoneLabel = (timeZone) => {
    const foundTimeZone = timeZoneOptions.find((item) => item.value === timeZone);
    return foundTimeZone ? foundTimeZone.label : 'IST';
  };
  const timeZoneToShow = timeZone && getTimeZoneLabel(timeZone);

  // const interviewDate = parsedStartTime.local().format('DD MMM. YYYY');
  return(<div>
    <div>{startDate} </div>
    <div>{startLocalTime} - {endlocalTime} {timeZoneToShow}</div>
  </div>)
};  

export const Capitalize = (str) => {
  if (typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const DeleteKeysFromSession = (keys) => {
  if (Array.isArray(keys) && keys.length > 0) {
      keys.forEach(key => {
          sessionStorage.removeItem(key);
      });
  }
}

export const formatHoursAndMinutes = (hours) => {
  const totalMinutes = Math.floor(hours * 60); // Convert hours to total minutes
  const hrs = Math.floor(totalMinutes / 60); // Get the whole hours
  const mins = totalMinutes % 60; // Get remaining minutes
  const secs = Math.round((hours * 3600) % 60); // Get seconds from the fractional part of hours

  const paddedHours = String(hrs).padStart(2, '0');
  const paddedMinutes = String(mins).padStart(2, '0');
  // const paddedSeconds = String(secs).padStart(2, '0');

  return `${paddedHours}:${paddedMinutes}:00`; // Format in HH:mm:ss
};

// export const downloadFileOnSystem = async (fileUrl) => { // this is used previously but some time it is giving cors error on some machine
//   if (!fileUrl) {
//     console.error("No file URL provided.");
//     return;
//   }

//   try {
//     const response = await fetch(fileUrl, { method: "GET", mode: "cors" });

//     if (!response.ok) {
//       throw new Error(`Failed to fetch file: ${response.status} ${response.statusText}`);
//     }

//     const blob = await response.blob();
//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;

//     // Extract filename safely
//     const pathname = new URL(fileUrl).pathname;
//     const rawName = pathname.substring(pathname.lastIndexOf("/") + 1);
//     const decodedName = decodeURIComponent(rawName.split("?")[0]) || "downloaded-file";

//     link.download = decodedName;

//     document.body.appendChild(link);
//     link.click();

//     // Cleanup
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Download failed:", error);
//   }
// };

export const downloadFileOnSystem = (fileUrl) => {
  if (!fileUrl) {
    console.error("No file URL provided.");
    return;
  }

  try {
    const isBlobUrl = fileUrl.startsWith("blob:");
    const isDataUrl = fileUrl.startsWith("data:");

    const link = document.createElement("a");
    link.href = fileUrl;
    link.target = "_blank"; // optional: avoid popup blocker
    link.rel = "noopener noreferrer";

    // Try to infer filename
    let fileName = "download";

    try {
      const pathname = new URL(fileUrl).pathname;
      const rawName = pathname.substring(pathname.lastIndexOf("/") + 1);
      fileName = decodeURIComponent(rawName.split("?")[0]) || "download";
    } catch (e) {
      // For blob/data URLs or invalid URLs
      fileName = "download";
    }

    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error("Error while downloading file:", err);
  }
};
